//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
import TooltipMixins from "./mixins/tooltip";
export default {
  mixins: [TooltipMixins],
  props: {
    spec: {
      type: Object,
      required: true
    }
  },
  data: function data() {
    return {
      styles: {}
    };
  },
  methods: {
    $ready: function $ready() {
      var _this = this;

      this.$initAccessories();
      var styles = this.genericStyles(Object.assign({}, this.spec));
      this.styles = styles;

      if (this.spec.url) {
        var image = new Image();
        image.src = this.spec.url;

        image.onload = function () {
          var fit = _this.spec.fit || "clip";

          switch (fit) {
            case "crop":
              _this.fitCrop(image);

              return;

            default:
              _this.fitClip(image);

          }
        };
      }
    },
    fitClip: function fitClip(image) {
      var width, height;
      var aspectRatio = image.naturalWidth / image.naturalHeight;

      if (this.spec.width == "matchParent") {
        width = "100%"; // This breaks the image height when displayed in a badge.
        // height = `${100 / aspectRatio}%`;
      } else {
        if (this.spec.width) {
          width = "".concat(this.spec.width, "px");
          height = "".concat(this.spec.width / aspectRatio, "px");
        } else if (this.spec.height) {
          width = "".concat(this.spec.height * aspectRatio, "px");
          height = "".concat(this.spec.height, "px");
        }
      }

      Vue.set(this.styles, "width", width);
      Vue.set(this.styles, "height", height);
    },
    fitCrop: function fitCrop(image) {
      var width, height;

      if (this.spec.width) {
        width = "".concat(this.spec.width, "px");
        height = "".concat(image.naturalHeight, "px");
      } else if (this.spec.height) {
        width = "".concat(image.naturalWidth, "px");
        height = "".concat(this.spec.height, "px");
      }

      Vue.set(this.styles, "width", width);
      Vue.set(this.styles, "height", height);
    }
  }
};